module.exports = __webpack_public_path__ + "img/superok-h&s.db259083.jpg";